import React from 'react';
import {
  BookOpen,
  CalendarClock,
  Database,
  Settings2,
  Languages,
} from 'lucide-react';
import FeatureSection from './FeatureSection';

const features = [
  {
    title: 'Dynamic Knowledge Base',
    desc: 'Upload PDF, Word, Excel, CSV or TXT files — or pull straight from Google Drive — and the AI is trained instantly.',
    icon: <BookOpen size={20} />,
    bg: '#e0f7fe',
    color: '#06b6ec',
  },
  {
    title: 'Google Ecosystem Sync',
    desc: 'Log every conversation in Google Sheets and check real-time availability via Google Calendar.',
    icon: <CalendarClock size={20} />,
    bg: '#dcfce7',
    color: '#22c55e',
  },
  {
    title: 'Database Connectivity',
    desc: 'Plug directly into MySQL, PostgreSQL, SQL Server, MongoDB or SQLite for live answers from your systems of record.',
    icon: <Database size={20} />,
    bg: '#ede9fe',
    color: '#8b5cf6',
    badge: 'Available on Enterprise Plan',
  },
  {
    title: 'Customisable System Prompts',
    desc: 'Define the agent\'s identity, professional tone and exact behavioural rules — make it sound like your best rep.',
    icon: <Settings2 size={20} />,
    bg: '#fef3c7',
    color: '#d97706',
  },
  {
    title: 'Multilingual Detection',
    desc: 'Auto-detects your customer\'s language and can be set to respond in a specific format or style.',
    icon: <Languages size={20} />,
    bg: '#fee2e2',
    color: '#ef4444',
  },
];

export default function AIKnowledge() {
  const visual = (
    <div className="knowledgeCard">
      <div className="knowledgeCard__head">
        <span className="knowledgeCard__title">Training Sources</span>
        <span className="knowledgeCard__count">7 files · synced</span>
      </div>
      <ul className="knowledgeCard__list">
        <li><span className="ext ext--pdf">PDF</span> Product-Catalog-2026.pdf <span className="ok">✓</span></li>
        <li><span className="ext ext--doc">DOC</span> Refund-Policy.docx <span className="ok">✓</span></li>
        <li><span className="ext ext--xls">XLS</span> Pricing-Tiers.xlsx <span className="ok">✓</span></li>
        <li><span className="ext ext--csv">CSV</span> FAQ-Master.csv <span className="ok">✓</span></li>
        <li><span className="ext ext--drv">DRV</span> Google Drive · /brand-voice <span className="ok">✓</span></li>
      </ul>
      <div className="knowledgeCard__foot">
        <span className="dot dot--green" /> AI re-trained 2 min ago
      </div>
    </div>
  );

  return (
    <FeatureSection
      id="knowledge"
      eyebrow="AI Knowledge · Advanced Logic"
      title="Train it once. It learns everything."
      description="From PDFs and spreadsheets to live enterprise databases — AINA can pull the right answer from whatever source you give it, in whatever language your customer prefers."
      features={features}
      variant="alt"
      visual={visual}
    />
  );
}
